import { Group, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddFaqCategory = ({
  opened,
  setOpened,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      faqCatName: "",
      faqCatNote: "",
      faqCode: "",
    },

    validate: {
      faqCatName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alpha Numeric Name with 2 or more characters",
      faqCode: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Please enter a valid code",
      faqCatNote: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });
  useEffect(() => {
    if (editModalState) {
      form.setFieldValue("faqCatName", editData.faqCatName);
      form.setFieldValue("faqCatNote", editData.faqCatNote);
      form.setFieldValue("faqCode", editData.faqCode);
    }
  }, [opened]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.faqCategoryId = editData._id;
      url = "faqCategory/editFaqCategory";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "faqCategory/addFaqCategory";
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };
  // const onSubmit = (values) => {
  //   addFaqCategory(values, setOpened, setUpdate);
  // };
  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        FAQ Category Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter FAQ Category Name"
        form={form}
        validateName="faqCatName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />
      <Text mb={0} weight={500}>
        FAQ Category Code
      </Text>
      <InputField
        width="100%"
        placeholder="Enter FAQ Category Code"
        form={form}
        validateName="faqCode"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Text mt="md" mb={0} weight={500}>
        FAQ Category Note
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter FAQ Category Note"
        form={form}
        validateName="faqCatNote"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Update" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );
  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit FAQ Category" : "Add New FAQ Category"}
      form={form}
    />
  );
};
